import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import usePage from '../../hooks/usePage'
import { FlexColumn, FlexRow } from '../../components/atoms/layout/Flex'
import Label from '../../components/atoms/display/Label'
import Button from '../../components/atoms/inputs/Button'
import AgreementTable from '../../components/organisms/agreement/AgreementTable'
import TabView from '../../components/atoms/navigation/TabView'
import AgreementCreateDialog from '../../components/organisms/agreement/AgreementCreateDialog'
import useAgreements from '../../hooks/useAgreements'
import { CompanySelectors } from '../../store/company/selectors'
import SearchField from '../../components/molecules/inputs/SearchField'
import Alert from '../../components/atoms/feedback/Alert'
import AgreementSettingDialog from '../../components/organisms/company/AgreementSettingDialog'
import AvatarUserStepper from '../../components/molecules/display/AvatarUserStepper'

export default function AgreementsPage() {
  const { changeTitle } = usePage()
  const [agreementCreateDialog, setAgreementCreateDialog] = useState(false)
  const [tab, setTab] = useState('confirmation-required')
  const [settingsDialog, setSettingsDialog] = useState(false)
  const agreements = useAgreements()
  const company = useSelector(CompanySelectors.company)
  const [keyword, setKeyword] = useState<string | undefined>()

  useEffect(() => {
    changeTitle('契約管理')
  }, [changeTitle])

  return (
    <FlexColumn>
      <FlexRow align="center">
        <Label text="承認フロー" />
        <Button height="small" size="sm" onClick={() => setSettingsDialog(true)}>
          設定
        </Button>
        {agreements.settings && (
          <AgreementSettingDialog
            settings={agreements.settings}
            open={settingsDialog}
            onClose={() => setSettingsDialog(false)}
          />
        )}
      </FlexRow>
      {agreements.settings?.users.length === 0 && <Alert severity="info">承認フローは設定されていません</Alert>}
      <AvatarUserStepper users={agreements.settings?.users.map((agreementUser) => agreementUser.user) ?? []} />
      <FlexRow align="center">
        <Label text="契約一覧" />
        <Button
          height="small"
          disabled={company?.representative?.acceptedAt == null}
          onClick={() => setAgreementCreateDialog(true)}
        >
          新規契約
        </Button>
      </FlexRow>
      <SearchField onChange={setKeyword} value={keyword} />
      <TabView
        value={tab}
        onChange={setTab}
        tabs={[
          {
            value: 'confirmation-required',
            label: `要確認 (${agreements.getCompanyAgreements(keyword).length})`,
            panel: <AgreementTable agreements={agreements.getCompanyAgreements(keyword)} status="自社確認中" />,
          },
          {
            value: 'client-confirmation',
            label: `取引先確認中 (${agreements.getClientAgreements(keyword).length})`,
            panel: <AgreementTable agreements={agreements.getClientAgreements(keyword)} status="取引先確認中" />,
          },
          {
            value: 'accepted',
            label: `締結済み (${agreements.getAcceptedAgreements(keyword).length})`,
            panel: <AgreementTable agreements={agreements.getAcceptedAgreements(keyword)} status="締結済み" />,
          },
          {
            value: 'reject',
            label: `却下 (${agreements.getRejectAgreements(keyword).length})`,
            panel: <AgreementTable agreements={agreements.getRejectAgreements(keyword)} status="却下済み" />,
          },
        ]}
      />
      <AgreementCreateDialog open={agreementCreateDialog} onClose={() => setAgreementCreateDialog(false)} />
    </FlexColumn>
  )
}
